import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http'; 
import { Label, Color, SingleDataSet } from 'ng2-charts';
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js'
import { LocalStorageService } from 'ngx-webstorage';
import {DashboardService} from '../../services/dashboard.service';
import { SharedService, DataService } from 'src/app/shared/services';
import { ActivatedRoute, Router } from '@angular/router';

import { NgxSpinnerService } from 'ngx-spinner';
import { User} from '../../../auth/models';
import { DatePipe } from '@angular/common';
import { FormGroup,FormBuilder, FormControl, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { DocViewerDialogComponent } from 'src/app/doc-viewer/doc-viewer-dialog/doc-viewer-dialog.component';
import { DialogService } from 'primeng/dynamicdialog';
import { VMSConstants } from 'src/app/shared/constants/vms-constants';
import { ICompanyCOIChangeRequestDetails } from 'src/app/users/models/company.model';
import Quill from 'quill';
import ImageUploader from 'quill-image-uploader';
import { CompanyCOIChangeRequestStatus, CompanyDocumentType, DvmsSystemAlertDisplayPages, LookupCategory } from 'src/app/shared/enums/EnumsVMS';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DVMSSystemAlertsService } from 'src/app/admin/services';
import { ITasks, IDashboardCount } from '../../models';
import { ILookupCategory } from '../../../shared/models/lookup.model';
import { IGlobalSearchParam } from '../../../shared/models/Global-Search.model';
Quill.register("modules/imageUploader", ImageUploader);
@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ ConfirmationService,MessageService]
})
export class AdminDashboardComponent implements OnInit {
  
  @ViewChild('generalLiablityEffDate') gLEffDatepicker;
  @ViewChild('generalLiablityExpDate') gLExpDatepicker;
  @ViewChild('automobileLiabilityEffDate') aLEffDatepicker;
  @ViewChild('automobileLiablityExpDate') aLExpDatepicker;
  @ViewChild('umbrellaLiablityEffDate') uLEffDatepicker;
  @ViewChild('umbrellaLiabilityExpDate') uLExpDatepicker;
  @ViewChild('workersCompensationEffDate') wCEffDatepicker;
  @ViewChild('workersCompensationExpDate') wCExpDatepicker;
  @ViewChild('professtionalLiabilityEffDate') pLEffDatepicker;
  @ViewChild('PrefessionalLiabilityExpDate') pLExpDatepicker;
  showInterviewReport: boolean = false;
  dashboardCount: IDashboardCount;
  reqTotalCount:number = 0;
  requisitionOpenTotal:number = 0;
  requisitionActiveTotal:number = 0;
  submittedApplicants:number = 0;
  
  scheduledInterviews:number = 0;
  reScheduledInterviews:number = 0;
  acceptedInterviews:number = 0;

  offerInitiated:number = 0;
  offerNegotiated:number = 0;
  offerAccepted:number = 0;

  invoiceApproved:number = 0;
  invoiceRejected:number = 0;
  invoicePaymentonHold:number = 0;

  recentProjectMetrics:any;
  companyCOIChangeRequest:any;
  COIChangeRequestDetailsDialog:boolean = false;
  companyCOIDetailsUpdateForm: FormGroup;
  glEffectiveDate: Date;
  glExpiryDate: Date;
  alEffectiveDate: Date;
  alExpiryDate: Date;
  ulEffectiveDate: Date;
  ulExpiryDate: Date;
  wcEffectiveDate: Date;
  wcExpiryDate: Date;
  plEffectiveDate: Date;
  plExpiryDate: Date;
  comments:any;
  requestId;any;
  companyCOIChangeRequestDueList:any;
  companyCOIChangeRequestArchiveList:any;
  OnboardProcessApprovalPendingAlertsRequest:any;
  coiFileDocUrlOnRequest: string = "";
  showCOIFormFilePreviewEnableOnRequest: boolean = false;
  rejectionNotes:string;
  rejectionNotesDilaog:boolean = false;
  //insuranceFileURL:any;
  documentURL:any;
  documentTypeId:any;
  notesFormControl = new FormControl("",[Validators.required, this.editorMaxLength(500)]);
  isUploadCompleted = false;
  editorModules = {
    toolbar: [   
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }], 
        [{ 'font': [] }],   
        ['bold', 'italic', 'underline', 'strike'], 
        [{ 'color': [] }, { 'background': [] }], 
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'align': [] }],
        ['link', 'image']
    ], imageUploader: {
      upload: (file) => {
        return new Promise((resolve, reject) => {
          if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg') {
            if (file.size < 2097152) {
              this.isUploadCompleted = true;
              this.sharedService.uploadEditorImage(file).then(res => {
                this.isUploadCompleted = false;
                resolve(VMSConstants.editiorImageBaseUrl + res.substring(1));
              }).catch(err => {
                reject(err);
              })
            } else {
              reject('Size too large');
            }
          }
          else {
            reject('Unsupported type');
          }
        });
      },
    },
  };
  approvePopUpModel = {
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'font': [] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'align': [] }]
    ]
  }
  commentsFormControl = new FormControl("", [this.editorMaxLength(500)]);
  ///////////bar chart ////////////////////  
public barChartOptions = {
  scaleShowVerticalLines: false,
  responsive: true,
  scales: {
    yAxes: [
      {
       scaleLabel: {
        display: true,
        labelString: "Count",
       },
      },
     ]
  }
}; 

public barChartType = 'bar';
public barChartLegend = true; 
 url = '../../assets/data.json';

 barchart : any;
 Linechart :any;  
Recruiter = [];  
MonthCount: ChartDataSets[] = [] ;
///////////bar chart ////////////////////

/////////polar chart////////////////////////

public polarAreaChartLabels: Label[] = [];
public polarAreaChartData: SingleDataSet = [];

placementchartdataurl = '../../assets/placementchart.json';
public polarAreaLegend = true;
public polarAreaChartType: ChartType = 'polarArea';

public polarAreaChartColors = [
  {backgroundColor: ['#1769aa', '#ffc107', '#e91e63', '#008074', '#852196'],},
];

////////////////polar chart////////////////////////////////


/////////////////// Pie Chart//////////////////////////////

public PieChartOptions: ChartOptions = {
  responsive: true,
  legend: {
    position: 'top',
  },
  plugins: {
    datalabels: {
      formatter: (value, ctx) => {
        const label = ctx.chart.data.labels[ctx.dataIndex];
        return "25";
      },
    },
  }
};
public PieChartLabels: Label[];
public PieChartData: number[];
public PieChartType: ChartType = 'pie';
public PieChartLegend = true;
public PieChartColors = [
  {
    backgroundColor: ['#6ebe71', '#ffc107', '#30c9dc', '#f1749e', '#852196'],
  },
];
Requirementchartdataurl = '../../assets/requirementchart.json';
public RequirementChartView : boolean = false;
  recentRequirements: any;
  recentInterviews: any;
  currentUser: any;
  companyName: any;
  userRole: any;
  placementStatus: any;
  loading: boolean = true;
  
  companyId: any;
  userid: any;
  filters;
  filterCondition;
  sortField:string = 'CreateDate';
 sortOrder:string = 'desc';
  totalFilter:string ='';
 pageNo: number =1;
 pageSize: number =5;
 oldPageNo: number =1;
 oldPageSize: number =5;

 filterItem = [
  { value: 'vendorName', header: 'Vendor Name' },
  { value: 'documentType', header: 'Document Type' },
];
documentTypes: ILookupCategory[] = [];
dueFilterForm: FormGroup;
appliedFilters:{field:string,matchMode:string,value:string}[]=[];
dashboardDueSearchParam:IGlobalSearchParam;
archiveFilterForm: FormGroup;
appliedArchiveFilters:{field:string,matchMode:string,value:string}[]=[];
dashboardArchiveSearchParam:IGlobalSearchParam;
  ////////////////// Pie Chart /////////////////////////////

  loggedInUserProfile: User;
  showAlertMessage;
  alertMessage;
  applicantName:string="";
  approveNCANotesDilaog:boolean=false;

  constructor(private httpClient : HttpClient,private dashboardService: DashboardService,
    private storage: LocalStorageService, private spinner: NgxSpinnerService,
    private sharedService: SharedService, private route: ActivatedRoute, private datepipe: DatePipe,
    private router: Router,private formBuilder: FormBuilder, private dialogService: DialogService, private confirmationService: ConfirmationService,
    private dvmsSystemAlertsService: DVMSSystemAlertsService,private messageService: MessageService,
    ) {

      this.spinner.show();
      setTimeout(() => {
        this.spinner.hide();
      }, 1000);

      this.currentUser = null;
      this.companyName = null;
      this.userRole = null;
      this.userid = null;
   }

   
getLoggedInUserProfile()
{
  this.loggedInUserProfile = this.sharedService.getLoggedInUserProfile();
  /*console.log('this.loggedInUserProfile');
  console.log(this.loggedInUserProfile.cid);*/
}

checkViewPermission()
{
  var loggedInUserRole = this.sharedService.getLoggedInUserRoles();
  if(loggedInUserRole=="Super Admin" || loggedInUserRole=="Admin" || loggedInUserRole=="VMS Analyst"||loggedInUserRole=="Guest")
  {
    
  } else {
    this.router.navigateByUrl('/login');
  }
  
}

checkAlertMessage()
{
  this.dvmsSystemAlertsService.checkDvmsSystemAlertByPageId(DvmsSystemAlertDisplayPages.DashboardSuperAdminPage).subscribe((data:any)=>{
    if(data.hasAlertAvailable == true)
    {
      this.showAlertMessage = true;
      this.alertMessage = data.alertMessage;
    }
  }); 
}

  ngOnInit(): void {
  this.getLoggedInUserProfile();
  this.checkAlertMessage();
  this.bindDashboardCount();
      this.getRecentRequirements();

      
    this.bindActivityTypeSummaryGraphData();
    this.GetReqByClientChartData();
    this.GetPlacementByVendorChartData();
    this.getPlacementStatus();

  this.checkViewPermission();
  this.getCompanyCOIChangeRequestDueList();
  this.getCompanyCOIChangeRequestArchiveList();
  this.companyCOIDetailsForm();
  this.documentForm();
  this.getDocumentType();
  this.intiateArchiveFilterForm();
  this.geGetVendorOnboardPendingAlertsRequest();
  }
  companyCOIDetailsForm()
  {
    this.companyCOIDetailsUpdateForm = this.formBuilder.group({
      glEffDate: ['', [Validators.required]],
      glExpDate: ['', [Validators.required]],
      alEffDate: ['', [Validators.required]],
      alExpDate: ['', [Validators.required]],
      ulEffDate: ['', [Validators.required]],
      ulExpDate: ['', [Validators.required]],
      wcEffDate: ['', [Validators.required]],
      wcExpDate: ['', [Validators.required]],
      plEffDate: ['', [Validators.required]],
      plExpDate: ['', [Validators.required]],
      comments:[]
    });
  }  closeCOIRequestDialog()
  {
    this.companyCOIDetailsForm();
 
    this.gLEffDatepicker.overlayVisible = false;
    this.gLExpDatepicker.overlayVisible = false;
    this.aLEffDatepicker.overlayVisible = false;
    this.aLExpDatepicker.overlayVisible = false;
    this.uLEffDatepicker.overlayVisible = false;
    this.uLExpDatepicker.overlayVisible = false;
    this.wCEffDatepicker.overlayVisible = false;
    this.wCExpDatepicker.overlayVisible = false;
    this.pLEffDatepicker.overlayVisible = false;
    this.pLExpDatepicker.overlayVisible = false;
    
  }

  bindDashboardCount() {
    this.dashboardService.adminDashboardCount().subscribe((data: any) => {
      this.dashboardCount = data;
      // this.requisitionOpenTotal = data[0].requisitionOpenTotal;
      // this.requisitionActiveTotal = data[0].requisitionActiveTotal;     
      // this.submittedApplicants = data[0].submittedApplicants;
     
      // this.scheduledInterviews = data[0].scheduledInterviews;
      // this.reScheduledInterviews = data[0].reScheduledInterviews;
      // this.acceptedInterviews = data[0].acceptedInterviews;

      // this.offerInitiated= data[0].offerInitiated;
      // this.offerNegotiated= data[0].offerNegotiated;
      // this.offerAccepted= data[0].offerAccepted;
    
      // this.invoiceApproved= data[0].invoiceApproved;
      // this.invoiceRejected= data[0].invoiceRejected;
      // this.invoicePaymentonHold= data[0].invoicePaymentonHold;
    });
 
  }

  bindActivityTypeSummaryGraphData() {
    this.dashboardService.getActivityTypeSummaryCount(this.companyName,this.userRole).subscribe((data: any) => {
      this.Recruiter.push(data[0].activityType); 
      this.MonthCount = data[1].count;
    });
  }

  GetReqByClientChartData() {
    this.dashboardService.getReqByClientChartCount(this.companyName,this.userRole).subscribe((data: any) => {
      this.PieChartLabels = data[0].clients; 
      this.PieChartData = data[1].requirementCount;
      this.RequirementChartView = true;

      this.PieChartOptions = {
        responsive: true,
        legend: {
          position: 'top',
        },
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              const label = ctx.chart.data.labels[ctx.dataIndex];
              return "25";
            },
          },
        }
      };
    });
  }

  GetPlacementByVendorChartData() {
    this.dashboardService.getPlacementByClientChartCount(this.companyName,this.userRole).subscribe((data: any) => {
      //console.log(data);
      this.polarAreaChartLabels = data[0].vendors; 
      this.polarAreaChartData = data[1].placementCount;
    });
   }
  getRecentRequirements()
  {
    this.dashboardService.getRecentRequirements(this.companyName,this.userRole).subscribe((data: any) => {
      this.recentRequirements =data;
     });

  }
  getRecentInterviews()
  {
    this.dashboardService.getRecentInterviews(this.companyName,this.userRole).subscribe((data: any) => {
     
      this.recentInterviews =data;
      
     });
  }
  getPlacementStatus()
  {
    this.dashboardService.getPlacementStatus(this.companyName,this.userRole).subscribe((data: any) => {
     
      this.placementStatus =data;
      
     });
  }
  
  getCompanyCOIChangeRequestDueList()
  {
    //this.appliedFilters.push({ field: "", matchMode: "", value: "" })
    this.dashboardDueSearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         sortOrder:this.sortOrder
       };
    this.dashboardService.getAllDueCompanyDocumentChangeRequestList(this.dashboardDueSearchParam).subscribe((data:any)=>{
      this.companyCOIChangeRequestDueList = data;

    });
  }
  getCompanyCOIChangeRequestArchiveList()
  {
    this.dashboardArchiveSearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedArchiveFilters,
         sortOrder:this.sortOrder
       };
    this.dashboardService.getAllArchiveCompanyCOIChangeRequestList(this.dashboardArchiveSearchParam).subscribe((data:any)=>{
      this.companyCOIChangeRequestArchiveList = data;
      console.log(data);
    });
  }
  documentName:string;
  vendorName:string;
  documnetChangeRequestDetailsDialog:boolean;
  isApproveComments:boolean= false;
  approveNotesDilaog:boolean=false;
  Header:string="";
  getSelectedChangeRequestDetails(applicantName,documentId,vendorName)
  {
    this.isApproveComments=false;
   this.vendorName=vendorName;
   this.applicantName=applicantName;
    this.dashboardService.getCompanyDocumentById(documentId).subscribe((data:any)=>{
      console.log(data);
      this.requestId = data[0].documentId;
      this.documentTypeId= data[0].documentTypeId;
      if(data[0].azureURL == null || data[0].azureURL == undefined )
      {
        this.showCOIFormFilePreviewEnableOnRequest = false;
      }
      else{
        this.showCOIFormFilePreviewEnableOnRequest = true;
        this.documentURL=data[0].documentFileName;
        this.coiFileDocUrlOnRequest = data[0].azureURL;
      }
     

      if(data[0].documentTypeId == CompanyDocumentType.DD){
        this.documentName="DD";
        this.documnetChangeRequestDetailsDialog=true;
        this.isApproveComments=true;
        this.Header=this.documentName+ " Approval - " + vendorName;
      }
      else if(data[0].documentTypeId == CompanyDocumentType.Void_Cheque){
        this.documentName="Void Cheque"
        this.documnetChangeRequestDetailsDialog=true;
        this.isApproveComments=true;
        this.Header=this.documentName+ " Approval - " + vendorName;
      }
      else if(data[0].documentTypeId == CompanyDocumentType.COI){
        this.documentName="COI"
        
      this.glEffectiveDate = data[0].glEffDate != null ? new Date(data[0].glEffDate) : null;
      this.glExpiryDate = data[0].glExpDate != null ? new Date(data[0].glExpDate) : null;
      this.alEffectiveDate = data[0].alEffDate != null ? new Date(data[0].alEffDate) : null;
      this.alExpiryDate = data[0].alExpDate != null ? new Date(data[0].alExpDate) : null;
      this.ulEffectiveDate = data[0].ulEffDate != null ? new Date(data[0].ulEffDate) : null;
      this.ulExpiryDate = data[0].ulExpDate != null ? new Date(data[0].ulExpDate) : null;
      this.wcEffectiveDate = data[0].wcEffDate != null ? new Date(data[0].wcEffDate) : null;
      this.wcExpiryDate = data[0].wcExpDate != null ? new Date(data[0].wcExpDate) : null;;
      this.plEffectiveDate = data[0].plEffDate != null ? new Date(data[0].plEffDate) : null;
      this.plExpiryDate = data[0].plExpDate != null ? new Date(data[0].plExpDate) : null;
      this.gLEffDatepicker.overlayVisible = false;
      this.gLExpDatepicker.overlayVisible = false;
      this.aLEffDatepicker.overlayVisible = false;
      this.aLExpDatepicker.overlayVisible = false;
      this.uLEffDatepicker.overlayVisible = false;
      this.uLExpDatepicker.overlayVisible = false;
      this.wCEffDatepicker.overlayVisible = false;
      this.wCExpDatepicker.overlayVisible = false;
      this.pLEffDatepicker.overlayVisible = false;
      this.pLExpDatepicker.overlayVisible = false;
      this.companyCOIDetailsUpdateForm = this.formBuilder.group({
        glEffDate: new FormControl(this.glEffectiveDate ,[Validators.required]),
        glExpDate: new FormControl(this.glExpiryDate, [Validators.required]),
        alEffDate: new FormControl(this.alEffectiveDate, [Validators.required]),
        alExpDate: new FormControl(this.alExpiryDate, [Validators.required]),
        ulEffDate: new FormControl(this.ulEffectiveDate, [Validators.required]),
        ulExpDate: new FormControl(this.ulExpiryDate, [Validators.required]),
        wcEffDate: new FormControl(this.wcEffectiveDate, [Validators.required]),
        wcExpDate: new FormControl(this.wcExpiryDate, [Validators.required]),
        plEffDate: new FormControl(this.plEffectiveDate, [Validators.required]),
        plExpDate: new FormControl(this.plExpiryDate, [Validators.required]),
        comments: new FormControl(data[0].comments),
      });
      
      this.comments= data[0].comments;
      this.COIChangeRequestDetailsDialog =true;
      this.Header=this.documentName+ " Approval - " + vendorName;
      }
      else if(data[0].documentTypeId == CompanyDocumentType.W9){
        this.documentName="W9"
        this.documnetChangeRequestDetailsDialog=true;
        this.Header=this.documentName+ " Approval - " + vendorName;
      }
      else if(data[0].documentTypeId == CompanyDocumentType.I9){
        this.documentName="I9"
        this.documnetChangeRequestDetailsDialog=true;
        this.Header=this.documentName+ " Approval - " + vendorName;
      }
      else if(data[0].documentTypeId == CompanyDocumentType.E_Verification){
        this.documentName="E-Verification"
        this.documnetChangeRequestDetailsDialog=true;
        this.Header=this.documentName+ " Approval - " + vendorName;
      }
      else if(data[0].documentTypeId == CompanyDocumentType.NCA){
        this.documentName="NCA"
        this.documnetChangeRequestDetailsDialog=true;
        this.Header="NCA - " +this.applicantName+" - " + vendorName;
      }
      else if(data[0].documentTypeId == CompanyDocumentType.MSA){
        this.documentName="MSA"
        this.documnetChangeRequestDetailsDialog=true;
        this.Header=this.documentName+ " Approval - " + vendorName;
      }
      else if(data[0].documentTypeId == CompanyDocumentType.PO){
        this.documentName="PO"
        this.documnetChangeRequestDetailsDialog=true;
        this.Header=this.documentName+ " Approval - " + vendorName;
      }
      
    });
  }
  ShowInsuranceUploadedFileOnRequest() {
    if(this.documentName == "COI"){
      const ref = this.dialogService.open(DocViewerDialogComponent, {
        data: {
          fileUrl: this.coiFileDocUrlOnRequest,
          title: 'COI Preview',
          fileName: this.coiFileDocUrlOnRequest,
        },
        width: '100%',
        height: '100%',
        baseZIndex: 10000,
        showHeader: false,
      });
    }
    else if(this.documentName == "DD"){
      const ref = this.dialogService.open(DocViewerDialogComponent, {
        data: {
          fileUrl: this.coiFileDocUrlOnRequest,
          title: 'DD Preview',
          fileName: this.coiFileDocUrlOnRequest,
        },
        width: '100%',
        height: '100%',
        baseZIndex: 10000,
        showHeader: false,
      });
    }
    else if(this.documentName == "Void Cheque"){
      const ref = this.dialogService.open(DocViewerDialogComponent, {
        data: {
          fileUrl: this.coiFileDocUrlOnRequest,
          title: 'Void Cheque Preview',
          fileName: this.coiFileDocUrlOnRequest,
        },
        width: '100%',
        height: '100%',
        baseZIndex: 10000,
        showHeader: false,
      });
    }
    else if(this.documentName == "W9"){
      const ref = this.dialogService.open(DocViewerDialogComponent, {
        data: {
          fileUrl: this.coiFileDocUrlOnRequest,
          title: 'W9 Preview',
          fileName: this.coiFileDocUrlOnRequest,
        },
        width: '100%',
        height: '100%',
        baseZIndex: 10000,
        showHeader: false,
      });
    }
    else if(this.documentName == "I9"){
      const ref = this.dialogService.open(DocViewerDialogComponent, {
        data: {
          fileUrl: this.coiFileDocUrlOnRequest,
          title: 'I9 Preview',
          fileName: this.coiFileDocUrlOnRequest,
        },
        width: '100%',
        height: '100%',
        baseZIndex: 10000,
        showHeader: false,
      });
    }
    else if(this.documentName == "E-Verification"){
      const ref = this.dialogService.open(DocViewerDialogComponent, {
        data: {
          fileUrl: this.coiFileDocUrlOnRequest,
          title: 'E-Verification Preview',
          fileName: this.coiFileDocUrlOnRequest,
        },
        width: '100%',
        height: '100%',
        baseZIndex: 10000,
        showHeader: false,
      });
    }

    else if(this.documentName == "NCA"){
      const ref = this.dialogService.open(DocViewerDialogComponent, {
        data: {
          fileUrl: this.coiFileDocUrlOnRequest,
          title: 'NCA',
          fileName: this.coiFileDocUrlOnRequest,
        },
        width: '100%',
        height: '100%',
        baseZIndex: 10000,
        showHeader: false,
      });
    }
    else if(this.documentName == "MSA"){
      const ref = this.dialogService.open(DocViewerDialogComponent, {
        data: {
          fileUrl: this.coiFileDocUrlOnRequest,
          title: 'MSA',
          fileName: this.coiFileDocUrlOnRequest,
        },
        width: '100%',
        height: '100%',
        baseZIndex: 10000,
        showHeader: false,
      });
    }
    else if(this.documentName == "PO"){
      const ref = this.dialogService.open(DocViewerDialogComponent, {
        data: {
          fileUrl: this.coiFileDocUrlOnRequest,
          title: 'PO',
          fileName: this.coiFileDocUrlOnRequest,
        },
        width: '100%',
        height: '100%',
        baseZIndex: 10000,
        showHeader: false,
      });
    }
   
  }
  updateCompanyDocumentDetails({ value }: { value: ICompanyCOIChangeRequestDetails })
  {
    this.confirmationService.confirm({
      key:'COIUpdateConfirm',
      message :'<center>Do you want to Approve this document?</center>',
     //message: '<center>Please verify the email entered on the company profile is</center><center>'+' '+this.emailId.bold()+'.</center><center> You cannot change this email address after the save.</center><center>Select <strong>YES</strong> to continue or <strong>NO </strong>to go back and edit the email address',
     //message: '<center> Some insurance(s) are having an expired date. Would you like to approve the COI update request with expired dates? </center>',
     accept: () => {
      this.documnetChangeRequestDetailsDialog=false;
      value.documentId= this.requestId;
      value.documentFileName =  this.documentURL;
      value.documentTypeId=this.documentTypeId;
      value.modifiedBy = Number(this.loggedInUserProfile.uid);
      value.comments = null;
      this.dashboardService.UpdateCompanyCOIChangeRequest(value).subscribe((data:any)=>{
        this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'Document Approved successfully' })
        this.getCompanyCOIChangeRequestDueList();
        this.getCompanyCOIChangeRequestArchiveList();
        if(data.statusId ==CompanyCOIChangeRequestStatus.Approved)
        {
          //this.dashboardService.UpdateInvoiceStatus(data.companyId,Number(this.loggedInUserProfile.uid)).subscribe((data:any)=>{
  
         // });
        }
        if(this.documentTypeId ==CompanyDocumentType.NCA)
          {
            this.approveNCANotesDilaog=true;
          }
  
      });
     },
     reject:() =>{
     }});
  }
  updateDDCompanyDocumentDetails({ value }: { value: ICompanyCOIChangeRequestDetails })
  {
    this.documnetChangeRequestDetailsDialog=false;
    this.approveNotesDilaog=false;
    value.documentId= this.requestId;
    value.documentFileName =  this.documentURL;
    value.documentTypeId=this.documentTypeId;
    value.comments=this.commentsFormControl.value;
    value.modifiedBy = Number(this.loggedInUserProfile.uid);
    this.dashboardService.UpdateCompanyCOIChangeRequest(value).subscribe((data:any)=>{
      this.commentsFormControl.setValue("");
      this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'Document Approved successfully' })
      this.getCompanyCOIChangeRequestDueList();
      this.getCompanyCOIChangeRequestArchiveList();
      if(data.statusId ==CompanyCOIChangeRequestStatus.Approved)
      {
        //this.dashboardService.UpdateInvoiceStatus(data.companyId,Number(this.loggedInUserProfile.uid)).subscribe((data:any)=>{

       // });
      }

    });
  }
  updateCompanyCOIDetails({ value }: { value: ICompanyCOIChangeRequestDetails })
  {
    console.log(value);
    var currentDate =new Date();
    if(new Date(value.glExpDate) < new Date(currentDate) || new Date(value.alExpDate) < new Date(currentDate) || new Date(value.ulExpDate) < new Date(currentDate)
      || new Date(value.wcExpDate) < new Date(currentDate) || new Date(value.plExpDate) < new Date(currentDate))
      {
        this.confirmationService.confirm({
          key:'COIUpdateConfirm',
         //message: '<center>Please verify the email entered on the company profile is</center><center>'+' '+this.emailId.bold()+'.</center><center> You cannot change this email address after the save.</center><center>Select <strong>YES</strong> to continue or <strong>NO </strong>to go back and edit the email address',
         message: '<center> Some insurance(s) are having an expired date. Would you like to approve the COI update request with expired dates? </center>',
         accept: () => {
          this.COIChangeRequestDetailsDialog=false;
          value.documentId= this.requestId;
          value.documentFileName =  this.documentURL;
          value.documentTypeId=this.documentTypeId;
          value.modifiedBy = Number(this.loggedInUserProfile.uid);
          if (value.glEffDate != null) {
            var glEffDate = value.glEffDate.toDateString();
            let formatedglEffDate = new Date(glEffDate);
            var strformat = formatedglEffDate.toString();
            if (strformat.includes("India")) {
                formatedglEffDate.setDate(formatedglEffDate.getDate() + 1);
            }
            else {
                formatedglEffDate.setDate(formatedglEffDate.getDate());
            }
            value.glEffDate = (value.glEffDate === null) ? null : formatedglEffDate;
        }
        
        if (value.glExpDate != null) {
            var glExpDate = value.glExpDate.toDateString();
            let formatedglExpDate = new Date(glExpDate);
            var strformat = formatedglExpDate.toString();
            if (strformat.includes("India")) {
                formatedglExpDate.setDate(formatedglExpDate.getDate() + 1);
            }
            else {
                formatedglExpDate.setDate(formatedglExpDate.getDate());
            }
            value.glExpDate = (value.glExpDate === null) ? null : formatedglExpDate;
           
        }
        
        if (value.alEffDate != null) {
            var alEffDate = value.alEffDate.toDateString();
            let formatedalEffDate = new Date(alEffDate);
            var strformat = formatedalEffDate.toString();
            if (strformat.includes("India")) {
                formatedalEffDate.setDate(formatedalEffDate.getDate() + 1);
            }
            else {
                formatedalEffDate.setDate(formatedalEffDate.getDate());
            }
            value.alEffDate = (value.alEffDate === null) ? null : formatedalEffDate;
        }
        
        if (value.alExpDate != null) {
            var alExpDate = value.alExpDate.toDateString();
            let formatedalExpDate = new Date(alExpDate);
            var strformat = formatedalExpDate.toString();
            if (strformat.includes("India")) {
                formatedalExpDate.setDate(formatedalExpDate.getDate() + 1);
            }
            else {
                formatedalExpDate.setDate(formatedalExpDate.getDate());
            }
            value.alExpDate = (value.alExpDate === null) ? null : formatedalExpDate;
           
        }
        
        if (value.ulEffDate != null) {
            var ulEffDate = value.ulEffDate.toDateString();
            let formatedulEffDate = new Date(ulEffDate);
            var strformat = formatedulEffDate.toString();
            if (strformat.includes("India")) {
                formatedulEffDate.setDate(formatedulEffDate.getDate() + 1);
            }
            else {
                formatedulEffDate.setDate(formatedulEffDate.getDate());
            }
            value.ulEffDate = (value.ulEffDate === null) ? null : formatedulEffDate;
        }
        
        if (value.ulExpDate != null) {
            var ulExpDate = value.ulExpDate.toDateString();
            let formatedulExpDate = new Date(ulExpDate);
            var strformat = formatedulExpDate.toString();
            if (strformat.includes("India")) {
                formatedulExpDate.setDate(formatedulExpDate.getDate() + 1);
            }
            else {
                formatedulExpDate.setDate(formatedulExpDate.getDate());
            }
            value.ulExpDate = (value.ulExpDate === null) ? null : formatedulExpDate;
            
        }
        
        if (value.wcEffDate != null) {
            var wcEffDate = value.wcEffDate.toDateString();
            let formatedwcEffDate = new Date(wcEffDate);
            var strformat = formatedwcEffDate.toString();
            if (strformat.includes("India")) {
                formatedwcEffDate.setDate(formatedwcEffDate.getDate() + 1);
            }
            else {
                formatedwcEffDate.setDate(formatedwcEffDate.getDate());
            }
            value.wcEffDate = (value.wcEffDate === null) ? null : formatedwcEffDate;
        }
        
        if (value.wcExpDate != null) {
            var wcExpDate = value.wcExpDate.toDateString();
            let formatedwcExpDate = new Date(wcExpDate);
            var strformat = formatedwcExpDate.toString();
            if (strformat.includes("India")) {
                formatedwcExpDate.setDate(formatedwcExpDate.getDate() + 1);
            }
            else {
                formatedwcExpDate.setDate(formatedwcExpDate.getDate());
            }
            value.wcExpDate = (value.wcExpDate === null) ? null : formatedwcExpDate;
           
        }
        
        
        if (value.plEffDate != null) {
            var plEffDate = value.plEffDate.toDateString();
            let formatedplEffDate = new Date(plEffDate);
            var strformat = formatedplEffDate.toString();
            if (strformat.includes("India")) {
                formatedplEffDate.setDate(formatedplEffDate.getDate() + 1);
            }
            else {
                formatedplEffDate.setDate(formatedplEffDate.getDate());
            }
            value.plEffDate = (value.plEffDate === null) ? null : formatedplEffDate;
        }
        
        if (value.plExpDate != null) {
            var plExpDate = value.plExpDate.toDateString();
            let formatedplExpDate = new Date(plExpDate);
            var strformat = formatedplExpDate.toString();
            if (strformat.includes("India")) {
                formatedplExpDate.setDate(formatedplExpDate.getDate() + 1);
            }
            else {
                formatedplExpDate.setDate(formatedplExpDate.getDate());
            }
            value.plExpDate = (value.plExpDate === null) ? null : formatedplExpDate;
        }
          this.dashboardService.UpdateCompanyCOIChangeRequest(value).subscribe((data:any)=>{
            this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'Document Approved successfully' })
            this.getCompanyCOIChangeRequestDueList();
            this.getCompanyCOIChangeRequestArchiveList();
            if(data.statusId ==CompanyCOIChangeRequestStatus.Approved)
            {
              this.dashboardService.UpdateInvoiceStatus(data.companyId,Number(this.loggedInUserProfile.uid)).subscribe((data:any)=>{
      
              });
            }
      
          });
         },
         reject:() =>{
         }});
      }
      else{
        this.COIChangeRequestDetailsDialog=false;
        value.documentId= this.requestId;
        value.documentFileName =  this.documentURL;
        value.documentTypeId=this.documentTypeId;
        value.modifiedBy = Number(this.loggedInUserProfile.uid);
        if (value.glEffDate != null) {
          var glEffDate = value.glEffDate.toDateString();
          let formatedglEffDate = new Date(glEffDate);
          var strformat = formatedglEffDate.toString();
          if (strformat.includes("India")) {
              formatedglEffDate.setDate(formatedglEffDate.getDate() + 1);
          }
          else {
              formatedglEffDate.setDate(formatedglEffDate.getDate());
          }
          value.glEffDate = (value.glEffDate === null) ? null : formatedglEffDate;
      }
      
      if (value.glExpDate != null) {
          var glExpDate = value.glExpDate.toDateString();
          let formatedglExpDate = new Date(glExpDate);
          var strformat = formatedglExpDate.toString();
          if (strformat.includes("India")) {
              formatedglExpDate.setDate(formatedglExpDate.getDate() + 1);
          }
          else {
              formatedglExpDate.setDate(formatedglExpDate.getDate());
          }
          value.glExpDate = (value.glExpDate === null) ? null : formatedglExpDate;
         
      }
      
      if (value.alEffDate != null) {
          var alEffDate = value.alEffDate.toDateString();
          let formatedalEffDate = new Date(alEffDate);
          var strformat = formatedalEffDate.toString();
          if (strformat.includes("India")) {
              formatedalEffDate.setDate(formatedalEffDate.getDate() + 1);
          }
          else {
              formatedalEffDate.setDate(formatedalEffDate.getDate());
          }
          value.alEffDate = (value.alEffDate === null) ? null : formatedalEffDate;
      }
      
      if (value.alExpDate != null) {
          var alExpDate = value.alExpDate.toDateString();
          let formatedalExpDate = new Date(alExpDate);
          var strformat = formatedalExpDate.toString();
          if (strformat.includes("India")) {
              formatedalExpDate.setDate(formatedalExpDate.getDate() + 1);
          }
          else {
              formatedalExpDate.setDate(formatedalExpDate.getDate());
          }
          value.alExpDate = (value.alExpDate === null) ? null : formatedalExpDate;
         
      }
      
      if (value.ulEffDate != null) {
          var ulEffDate = value.ulEffDate.toDateString();
          let formatedulEffDate = new Date(ulEffDate);
          var strformat = formatedulEffDate.toString();
          if (strformat.includes("India")) {
              formatedulEffDate.setDate(formatedulEffDate.getDate() + 1);
          }
          else {
              formatedulEffDate.setDate(formatedulEffDate.getDate());
          }
          value.ulEffDate = (value.ulEffDate === null) ? null : formatedulEffDate;
      }
      
      if (value.ulExpDate != null) {
          var ulExpDate = value.ulExpDate.toDateString();
          let formatedulExpDate = new Date(ulExpDate);
          var strformat = formatedulExpDate.toString();
          if (strformat.includes("India")) {
              formatedulExpDate.setDate(formatedulExpDate.getDate() + 1);
          }
          else {
              formatedulExpDate.setDate(formatedulExpDate.getDate());
          }
          value.ulExpDate = (value.ulExpDate === null) ? null : formatedulExpDate;
          
      }
      
      if (value.wcEffDate != null) {
          var wcEffDate = value.wcEffDate.toDateString();
          let formatedwcEffDate = new Date(wcEffDate);
          var strformat = formatedwcEffDate.toString();
          if (strformat.includes("India")) {
              formatedwcEffDate.setDate(formatedwcEffDate.getDate() + 1);
          }
          else {
              formatedwcEffDate.setDate(formatedwcEffDate.getDate());
          }
          value.wcEffDate = (value.wcEffDate === null) ? null : formatedwcEffDate;
      }
      
      if (value.wcExpDate != null) {
          var wcExpDate = value.wcExpDate.toDateString();
          let formatedwcExpDate = new Date(wcExpDate);
          var strformat = formatedwcExpDate.toString();
          if (strformat.includes("India")) {
              formatedwcExpDate.setDate(formatedwcExpDate.getDate() + 1);
          }
          else {
              formatedwcExpDate.setDate(formatedwcExpDate.getDate());
          }
          value.wcExpDate = (value.wcExpDate === null) ? null : formatedwcExpDate;
         
      }
      
      
      if (value.plEffDate != null) {
          var plEffDate = value.plEffDate.toDateString();
          let formatedplEffDate = new Date(plEffDate);
          var strformat = formatedplEffDate.toString();
          if (strformat.includes("India")) {
              formatedplEffDate.setDate(formatedplEffDate.getDate() + 1);
          }
          else {
              formatedplEffDate.setDate(formatedplEffDate.getDate());
          }
          value.plEffDate = (value.plEffDate === null) ? null : formatedplEffDate;
      }
      
      if (value.plExpDate != null) {
          var plExpDate = value.plExpDate.toDateString();
          let formatedplExpDate = new Date(plExpDate);
          var strformat = formatedplExpDate.toString();
          if (strformat.includes("India")) {
              formatedplExpDate.setDate(formatedplExpDate.getDate() + 1);
          }
          else {
              formatedplExpDate.setDate(formatedplExpDate.getDate());
          }
          value.plExpDate = (value.plExpDate === null) ? null : formatedplExpDate;
      }
        this.dashboardService.UpdateCompanyCOIChangeRequest(value).subscribe((data:any)=>{
          this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'Document Approved successfully' })
          this.getCompanyCOIChangeRequestDueList();
          this.getCompanyCOIChangeRequestArchiveList();
          if(data.statusId ==CompanyCOIChangeRequestStatus.Approved)
          {
            this.dashboardService.UpdateInvoiceStatus(data.companyId,Number(this.loggedInUserProfile.uid)).subscribe((data:any)=>{
    
           });
          }
    
        });
      }
  }
  rejectCompanyCOIDetails({ value }: { value: ICompanyCOIChangeRequestDetails })
  {
    value.documentId= this.requestId;
    value.documentFileName =  this.documentURL;
    value.documentTypeId=this.documentTypeId;
    value.rejectionNotes = this.notesFormControl.value;
    value.modifiedBy = Number(this.loggedInUserProfile.uid);
    this.dashboardService.RejectCompanyCOIChangeRequest(value).subscribe((data:any)=>{
      this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'Document rejected successfully' })
      this.notesFormControl.setValue('');
      this.getCompanyCOIChangeRequestDueList();
      this.getCompanyCOIChangeRequestArchiveList();
    });
  }
  cancelNotes()
  {
    this.notesFormControl.setValue('');
  }
  editorMaxLength(maxlength): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      var regex = /(<([^>]+)>)/ig;
      var value = control.value;
      if (value == null) {
        return null;
      }
      var result = value.replace(regex, "");
      if (result.length > maxlength) {
        return { 'maxlengthError': true };
      } else {
        return null;
      }
    }
  }
  cancelApproval(){
    this.approveNotesDilaog=false;
    this.approveNCANotesDilaog=false;
    this.commentsFormControl.setValue("");
  }
  documentForm() {
    this.dueFilterForm = this.formBuilder.group({
      filterType:new FormControl('', [Validators.required]),
      documentType:new FormControl(''),
      filterValue:new FormControl('')
    })
  }
  
  get applicantDocumentFormControl() {
    return this.dueFilterForm.controls;
  }
  viewVendorInfo(tempVendorId){
    this.router.navigate(['/admin/vendor-onboard-approval-view',{tempVendorId: tempVendorId}]);
  }
  documentTypeEnable:boolean=true;
   getDocumentType() {
     
    this.sharedService.getLookupMasterByCategoryId(LookupCategory.CompanyDocumentType).subscribe((data: any) => {
      this.documentTypes = data;
      this.documentTypes = data.filter(item => item.description != 'MSA' && item.description != 'NCA' && item.description != 'PO');
    });
  }
  getDocumentTypeOnChange(event) {
    this.documentTypeId = event.value.lookupOrder;
  }
  getFilterTypeOnChange(event) {
    const filterValue = this.dueFilterForm.get('filterValue');
    const documentType = this.dueFilterForm.get('documentType');
    if(event.value == "vendorName")
    {
      this.documentTypeEnable = false;
      filterValue.setValidators([Validators.required,Validators.maxLength(100)]);
      documentType.clearValidators();
      documentType.setValue('');
    }
    
  else{
    documentType.setValidators([Validators.required]);
    filterValue.clearValidators();
    filterValue.setValue('');
    this.documentTypeEnable=true;
  }
  filterValue.updateValueAndValidity();
  documentType.updateValueAndValidity();
  }
  enableFilter:boolean=false;
  search({value}:{value:any}){
    this.appliedFilters = [];
    if(this.documentTypeEnable==false){
    this.appliedFilters.push({ field: value.filterType, matchMode: "contains", value: value.filterValue })
    this.dashboardDueSearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         sortOrder:this.sortOrder
       };
       this.dashboardService.getAllDueCompanyDocumentChangeRequestList(this.dashboardDueSearchParam).subscribe((data:any)=>{
        this.companyCOIChangeRequestDueList = data;
  
      });
      }
      else{
        this.appliedFilters.push({ field: value.filterType, matchMode: "custom-equals", value: value.documentType.description })
    this.dashboardDueSearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         sortOrder:this.sortOrder
       };
       this.dashboardService.getAllDueCompanyDocumentChangeRequestList(this.dashboardDueSearchParam).subscribe((data:any)=>{
        this.companyCOIChangeRequestDueList = data;
  
      });
      }
  }
  
  clearFilter(){
    this.appliedFilters = [];
    this.appliedFilters.push({ field: "", matchMode: "", value: "" })
    this.documentForm();
    this.getCompanyCOIChangeRequestDueList();
    this.appliedArchiveFilters = [];
    this.appliedArchiveFilters.push({ field: "", matchMode: "", value: "" })
    this.intiateArchiveFilterForm();
    this.getCompanyCOIChangeRequestArchiveList();
  }

  bindShowFilter() {
    this.enableFilter = (this.enableFilter ? false : true)
  }

  intiateArchiveFilterForm() {
    this.archiveFilterForm = this.formBuilder.group({
      filterType:new FormControl('', [Validators.required]),
      documentType:new FormControl(''),
      filterValue:new FormControl('')
    })
  }
  
  get intiateArchiveFormControl() {
    return this.archiveFilterForm.controls;
  }
  getArchiveDocumentTypeOnChange(event) {
    this.documentTypeId = event.value.lookupOrder;
  }
  archiveDocumentTypeEnable:boolean=true;
  getArchiveFilterTypeOnChange(event) {
    const filterValue = this.archiveFilterForm.get('filterValue');
    const documentType = this.archiveFilterForm.get('documentType');
    if(event.value == "vendorName")
    {
      this.archiveDocumentTypeEnable = false;
      filterValue.setValidators([Validators.required,Validators.maxLength(100)]);
      documentType.clearValidators();
      documentType.setValue('');
    }
    
  else{
    documentType.setValidators([Validators.required]);
    filterValue.clearValidators();
    filterValue.setValue('');
    this.archiveDocumentTypeEnable=true;
  }
  filterValue.updateValueAndValidity();
  documentType.updateValueAndValidity();
  }
  archiveSearch({value}:{value:any}){
    this.appliedArchiveFilters = [];
    if(this.archiveDocumentTypeEnable==false){
    this.appliedArchiveFilters.push({ field: value.filterType, matchMode: "contains", value: value.filterValue })
    this.dashboardArchiveSearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedArchiveFilters,
         sortOrder:this.sortOrder
       };
       this.dashboardService.getAllArchiveCompanyCOIChangeRequestList(this.dashboardArchiveSearchParam).subscribe((data:any)=>{
        this.companyCOIChangeRequestArchiveList = data;
      });
      }
      else{
        this.appliedArchiveFilters.push({ field: value.filterType, matchMode: "custom-equals", value: value.documentType.description })
    this.dashboardArchiveSearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedArchiveFilters,
         sortOrder:this.sortOrder
       };
       this.dashboardService.getAllArchiveCompanyCOIChangeRequestList(this.dashboardArchiveSearchParam).subscribe((data:any)=>{
        this.companyCOIChangeRequestArchiveList = data;
      });
      }
  }

  geGetVendorOnboardPendingAlertsRequest()
  {
    this.dashboardService.GetVendorOnboardProcessApprovalPendingAlerts().subscribe((data:any)=>{
      this.OnboardProcessApprovalPendingAlertsRequest = data;

    });
  }

  documnetReApproveDetailsDialog:boolean;
  reApproveCOIChangeRequestDetailsDialog:boolean=false;
  getReApproveRequestDetails(documentId,vendorName)
  {
    this.isApproveComments=false;
   this.vendorName=vendorName;
    this.dashboardService.getCompanyDocumentById(documentId).subscribe((data:any)=>{
      console.log(data);
      this.requestId = data[0].documentId;
      this.documentTypeId= data[0].documentTypeId;
      if(data[0].azureURL == null || data[0].azureURL == undefined )
      {
        this.showCOIFormFilePreviewEnableOnRequest = false;
      }
      else{
        this.showCOIFormFilePreviewEnableOnRequest = true;
        this.documentURL=data[0].documentFileName;
        this.coiFileDocUrlOnRequest = data[0].azureURL;
      }
     

      if(data[0].documentTypeId == CompanyDocumentType.DD){
        this.documentName="DD";
        this.documnetReApproveDetailsDialog=true;
        this.isApproveComments=true;
      }
      else if(data[0].documentTypeId == CompanyDocumentType.Void_Cheque){
        this.documentName="Void Cheque"
        this.documnetReApproveDetailsDialog=true;
        this.isApproveComments=true;
      }
      else if(data[0].documentTypeId == CompanyDocumentType.COI){
        this.documentName="COI"
        
      this.glEffectiveDate = data[0].glEffDate != null ? new Date(data[0].glEffDate) : null;
      this.glExpiryDate = data[0].glExpDate != null ? new Date(data[0].glExpDate) : null;
      this.alEffectiveDate = data[0].alEffDate != null ? new Date(data[0].alEffDate) : null;
      this.alExpiryDate = data[0].alExpDate != null ? new Date(data[0].alExpDate) : null;
      this.ulEffectiveDate = data[0].ulEffDate != null ? new Date(data[0].ulEffDate) : null;
      this.ulExpiryDate = data[0].ulExpDate != null ? new Date(data[0].ulExpDate) : null;
      this.wcEffectiveDate = data[0].wcEffDate != null ? new Date(data[0].wcEffDate) : null;
      this.wcExpiryDate = data[0].wcExpDate != null ? new Date(data[0].wcExpDate) : null;;
      this.plEffectiveDate = data[0].plEffDate != null ? new Date(data[0].plEffDate) : null;
      this.plExpiryDate = data[0].plExpDate != null ? new Date(data[0].plExpDate) : null;
      this.gLEffDatepicker.overlayVisible = false;
      this.gLExpDatepicker.overlayVisible = false;
      this.aLEffDatepicker.overlayVisible = false;
      this.aLExpDatepicker.overlayVisible = false;
      this.uLEffDatepicker.overlayVisible = false;
      this.uLExpDatepicker.overlayVisible = false;
      this.wCEffDatepicker.overlayVisible = false;
      this.wCExpDatepicker.overlayVisible = false;
      this.pLEffDatepicker.overlayVisible = false;
      this.pLExpDatepicker.overlayVisible = false;
      this.companyCOIDetailsUpdateForm = this.formBuilder.group({
        glEffDate: new FormControl(this.glEffectiveDate ,[Validators.required]),
        glExpDate: new FormControl(this.glExpiryDate, [Validators.required]),
        alEffDate: new FormControl(this.alEffectiveDate, [Validators.required]),
        alExpDate: new FormControl(this.alExpiryDate, [Validators.required]),
        ulEffDate: new FormControl(this.ulEffectiveDate, [Validators.required]),
        ulExpDate: new FormControl(this.ulExpiryDate, [Validators.required]),
        wcEffDate: new FormControl(this.wcEffectiveDate, [Validators.required]),
        wcExpDate: new FormControl(this.wcExpiryDate, [Validators.required]),
        plEffDate: new FormControl(this.plEffectiveDate, [Validators.required]),
        plExpDate: new FormControl(this.plExpiryDate, [Validators.required]),
        comments: new FormControl(data[0].comments),
      });
      
      this.comments= data[0].comments;
      this.reApproveCOIChangeRequestDetailsDialog =true;
      }
      else if(data[0].documentTypeId == CompanyDocumentType.W9){
        this.documentName="W9"
        this.documnetReApproveDetailsDialog=true;

      }
      else if(data[0].documentTypeId == CompanyDocumentType.I9){
        this.documentName="I9"
        this.documnetReApproveDetailsDialog=true;

      }
      else if(data[0].documentTypeId == CompanyDocumentType.E_Verification){
        this.documentName="E-Verification"
        this.documnetReApproveDetailsDialog=true;

      }
      else if(data[0].documentTypeId == CompanyDocumentType.MSA){
        this.documentName="MSA"
        this.documnetReApproveDetailsDialog=true;
      }
      else if(data[0].documentTypeId == CompanyDocumentType.PO){
        this.documentName="PO"
        this.documnetReApproveDetailsDialog=true;
      }
      else if(data[0].documentTypeId == CompanyDocumentType.NCA){
        this.documentName="NCA"
        this.documnetReApproveDetailsDialog=true;
      }
      
    });
  }

  reApproveCompanyCOIDetails({ value }: { value: ICompanyCOIChangeRequestDetails })
  {
    console.log(value);
    var currentDate =new Date();
    this.confirmationService.confirm({
      key:'COIUpdateConfirm',
      message :'<center>Re-approving this document will replace the existing document in the vendor company profile. Please re-verify the existing document in the vendor company profile before re-approving it.</center><br/><center>Would you like to re-approve this document?</center>',
     //message: '<center>Please verify the email entered on the company profile is</center><center>'+' '+this.emailId.bold()+'.</center><center> You cannot change this email address after the save.</center><center>Select <strong>YES</strong> to continue or <strong>NO </strong>to go back and edit the email address',
     //message: '<center> Some insurance(s) are having an expired date. Would you like to approve the COI update request with expired dates? </center>',
     accept: () => {
    if(new Date(value.glExpDate) < new Date(currentDate) || new Date(value.alExpDate) < new Date(currentDate) || new Date(value.ulExpDate) < new Date(currentDate)
      || new Date(value.wcExpDate) < new Date(currentDate) || new Date(value.plExpDate) < new Date(currentDate))
      {
        this.confirmationService.confirm({
          key:'ReApproveUpdateConfirm',
         //message: '<center>Please verify the email entered on the company profile is</center><center>'+' '+this.emailId.bold()+'.</center><center> You cannot change this email address after the save.</center><center>Select <strong>YES</strong> to continue or <strong>NO </strong>to go back and edit the email address',
         message: '<center> Some insurance(s) are having an expired date. Would you like to approve the COI update request with expired dates? </center>',
         accept: () => {
          this.reApproveCOIChangeRequestDetailsDialog=false;
          value.documentId= this.requestId;
          value.documentFileName =  this.documentURL;
          value.documentTypeId=this.documentTypeId;
          value.modifiedBy = Number(this.loggedInUserProfile.uid);
          if (value.glEffDate != null) {
            var glEffDate = value.glEffDate.toDateString();
            let formatedglEffDate = new Date(glEffDate);
            var strformat = formatedglEffDate.toString();
            if (strformat.includes("India")) {
                formatedglEffDate.setDate(formatedglEffDate.getDate() + 1);
            }
            else {
                formatedglEffDate.setDate(formatedglEffDate.getDate());
            }
            value.glEffDate = (value.glEffDate === null) ? null : formatedglEffDate;
        }
        
        if (value.glExpDate != null) {
            var glExpDate = value.glExpDate.toDateString();
            let formatedglExpDate = new Date(glExpDate);
            var strformat = formatedglExpDate.toString();
            if (strformat.includes("India")) {
                formatedglExpDate.setDate(formatedglExpDate.getDate() + 1);
            }
            else {
                formatedglExpDate.setDate(formatedglExpDate.getDate());
            }
            value.glExpDate = (value.glExpDate === null) ? null : formatedglExpDate;
           
        }
        
        if (value.alEffDate != null) {
            var alEffDate = value.alEffDate.toDateString();
            let formatedalEffDate = new Date(alEffDate);
            var strformat = formatedalEffDate.toString();
            if (strformat.includes("India")) {
                formatedalEffDate.setDate(formatedalEffDate.getDate() + 1);
            }
            else {
                formatedalEffDate.setDate(formatedalEffDate.getDate());
            }
            value.alEffDate = (value.alEffDate === null) ? null : formatedalEffDate;
        }
        
        if (value.alExpDate != null) {
            var alExpDate = value.alExpDate.toDateString();
            let formatedalExpDate = new Date(alExpDate);
            var strformat = formatedalExpDate.toString();
            if (strformat.includes("India")) {
                formatedalExpDate.setDate(formatedalExpDate.getDate() + 1);
            }
            else {
                formatedalExpDate.setDate(formatedalExpDate.getDate());
            }
            value.alExpDate = (value.alExpDate === null) ? null : formatedalExpDate;
           
        }
        
        if (value.ulEffDate != null) {
            var ulEffDate = value.ulEffDate.toDateString();
            let formatedulEffDate = new Date(ulEffDate);
            var strformat = formatedulEffDate.toString();
            if (strformat.includes("India")) {
                formatedulEffDate.setDate(formatedulEffDate.getDate() + 1);
            }
            else {
                formatedulEffDate.setDate(formatedulEffDate.getDate());
            }
            value.ulEffDate = (value.ulEffDate === null) ? null : formatedulEffDate;
        }
        
        if (value.ulExpDate != null) {
            var ulExpDate = value.ulExpDate.toDateString();
            let formatedulExpDate = new Date(ulExpDate);
            var strformat = formatedulExpDate.toString();
            if (strformat.includes("India")) {
                formatedulExpDate.setDate(formatedulExpDate.getDate() + 1);
            }
            else {
                formatedulExpDate.setDate(formatedulExpDate.getDate());
            }
            value.ulExpDate = (value.ulExpDate === null) ? null : formatedulExpDate;
            
        }
        
        if (value.wcEffDate != null) {
            var wcEffDate = value.wcEffDate.toDateString();
            let formatedwcEffDate = new Date(wcEffDate);
            var strformat = formatedwcEffDate.toString();
            if (strformat.includes("India")) {
                formatedwcEffDate.setDate(formatedwcEffDate.getDate() + 1);
            }
            else {
                formatedwcEffDate.setDate(formatedwcEffDate.getDate());
            }
            value.wcEffDate = (value.wcEffDate === null) ? null : formatedwcEffDate;
        }
        
        if (value.wcExpDate != null) {
            var wcExpDate = value.wcExpDate.toDateString();
            let formatedwcExpDate = new Date(wcExpDate);
            var strformat = formatedwcExpDate.toString();
            if (strformat.includes("India")) {
                formatedwcExpDate.setDate(formatedwcExpDate.getDate() + 1);
            }
            else {
                formatedwcExpDate.setDate(formatedwcExpDate.getDate());
            }
            value.wcExpDate = (value.wcExpDate === null) ? null : formatedwcExpDate;
           
        }
        
        
        if (value.plEffDate != null) {
            var plEffDate = value.plEffDate.toDateString();
            let formatedplEffDate = new Date(plEffDate);
            var strformat = formatedplEffDate.toString();
            if (strformat.includes("India")) {
                formatedplEffDate.setDate(formatedplEffDate.getDate() + 1);
            }
            else {
                formatedplEffDate.setDate(formatedplEffDate.getDate());
            }
            value.plEffDate = (value.plEffDate === null) ? null : formatedplEffDate;
        }
        
        if (value.plExpDate != null) {
            var plExpDate = value.plExpDate.toDateString();
            let formatedplExpDate = new Date(plExpDate);
            var strformat = formatedplExpDate.toString();
            if (strformat.includes("India")) {
                formatedplExpDate.setDate(formatedplExpDate.getDate() + 1);
            }
            else {
                formatedplExpDate.setDate(formatedplExpDate.getDate());
            }
            value.plExpDate = (value.plExpDate === null) ? null : formatedplExpDate;
        }
          this.dashboardService.UpdateCompanyCOIChangeRequest(value).subscribe((data:any)=>{
            this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'Document Approved successfully' })
            this.getCompanyCOIChangeRequestDueList();
            this.getCompanyCOIChangeRequestArchiveList();
            if(data.statusId ==CompanyCOIChangeRequestStatus.Approved)
            {
              this.dashboardService.UpdateInvoiceStatus(data.companyId,Number(this.loggedInUserProfile.uid)).subscribe((data:any)=>{
      
              });
            }
      
          });
         },
         reject:() =>{
         }});
      }
      else{
        this.reApproveCOIChangeRequestDetailsDialog=false;
        value.documentId= this.requestId;
        value.documentFileName =  this.documentURL;
        value.documentTypeId=this.documentTypeId;
        value.modifiedBy = Number(this.loggedInUserProfile.uid);
        if (value.glEffDate != null) {
          var glEffDate = value.glEffDate.toDateString();
          let formatedglEffDate = new Date(glEffDate);
          var strformat = formatedglEffDate.toString();
          if (strformat.includes("India")) {
              formatedglEffDate.setDate(formatedglEffDate.getDate() + 1);
          }
          else {
              formatedglEffDate.setDate(formatedglEffDate.getDate());
          }
          value.glEffDate = (value.glEffDate === null) ? null : formatedglEffDate;
      }
      
      if (value.glExpDate != null) {
          var glExpDate = value.glExpDate.toDateString();
          let formatedglExpDate = new Date(glExpDate);
          var strformat = formatedglExpDate.toString();
          if (strformat.includes("India")) {
              formatedglExpDate.setDate(formatedglExpDate.getDate() + 1);
          }
          else {
              formatedglExpDate.setDate(formatedglExpDate.getDate());
          }
          value.glExpDate = (value.glExpDate === null) ? null : formatedglExpDate;
         
      }
      
      if (value.alEffDate != null) {
          var alEffDate = value.alEffDate.toDateString();
          let formatedalEffDate = new Date(alEffDate);
          var strformat = formatedalEffDate.toString();
          if (strformat.includes("India")) {
              formatedalEffDate.setDate(formatedalEffDate.getDate() + 1);
          }
          else {
              formatedalEffDate.setDate(formatedalEffDate.getDate());
          }
          value.alEffDate = (value.alEffDate === null) ? null : formatedalEffDate;
      }
      
      if (value.alExpDate != null) {
          var alExpDate = value.alExpDate.toDateString();
          let formatedalExpDate = new Date(alExpDate);
          var strformat = formatedalExpDate.toString();
          if (strformat.includes("India")) {
              formatedalExpDate.setDate(formatedalExpDate.getDate() + 1);
          }
          else {
              formatedalExpDate.setDate(formatedalExpDate.getDate());
          }
          value.alExpDate = (value.alExpDate === null) ? null : formatedalExpDate;
         
      }
      
      if (value.ulEffDate != null) {
          var ulEffDate = value.ulEffDate.toDateString();
          let formatedulEffDate = new Date(ulEffDate);
          var strformat = formatedulEffDate.toString();
          if (strformat.includes("India")) {
              formatedulEffDate.setDate(formatedulEffDate.getDate() + 1);
          }
          else {
              formatedulEffDate.setDate(formatedulEffDate.getDate());
          }
          value.ulEffDate = (value.ulEffDate === null) ? null : formatedulEffDate;
      }
      
      if (value.ulExpDate != null) {
          var ulExpDate = value.ulExpDate.toDateString();
          let formatedulExpDate = new Date(ulExpDate);
          var strformat = formatedulExpDate.toString();
          if (strformat.includes("India")) {
              formatedulExpDate.setDate(formatedulExpDate.getDate() + 1);
          }
          else {
              formatedulExpDate.setDate(formatedulExpDate.getDate());
          }
          value.ulExpDate = (value.ulExpDate === null) ? null : formatedulExpDate;
          
      }
      
      if (value.wcEffDate != null) {
          var wcEffDate = value.wcEffDate.toDateString();
          let formatedwcEffDate = new Date(wcEffDate);
          var strformat = formatedwcEffDate.toString();
          if (strformat.includes("India")) {
              formatedwcEffDate.setDate(formatedwcEffDate.getDate() + 1);
          }
          else {
              formatedwcEffDate.setDate(formatedwcEffDate.getDate());
          }
          value.wcEffDate = (value.wcEffDate === null) ? null : formatedwcEffDate;
      }
      
      if (value.wcExpDate != null) {
          var wcExpDate = value.wcExpDate.toDateString();
          let formatedwcExpDate = new Date(wcExpDate);
          var strformat = formatedwcExpDate.toString();
          if (strformat.includes("India")) {
              formatedwcExpDate.setDate(formatedwcExpDate.getDate() + 1);
          }
          else {
              formatedwcExpDate.setDate(formatedwcExpDate.getDate());
          }
          value.wcExpDate = (value.wcExpDate === null) ? null : formatedwcExpDate;
         
      }
      
      
      if (value.plEffDate != null) {
          var plEffDate = value.plEffDate.toDateString();
          let formatedplEffDate = new Date(plEffDate);
          var strformat = formatedplEffDate.toString();
          if (strformat.includes("India")) {
              formatedplEffDate.setDate(formatedplEffDate.getDate() + 1);
          }
          else {
              formatedplEffDate.setDate(formatedplEffDate.getDate());
          }
          value.plEffDate = (value.plEffDate === null) ? null : formatedplEffDate;
      }
      
      if (value.plExpDate != null) {
          var plExpDate = value.plExpDate.toDateString();
          let formatedplExpDate = new Date(plExpDate);
          var strformat = formatedplExpDate.toString();
          if (strformat.includes("India")) {
              formatedplExpDate.setDate(formatedplExpDate.getDate() + 1);
          }
          else {
              formatedplExpDate.setDate(formatedplExpDate.getDate());
          }
          value.plExpDate = (value.plExpDate === null) ? null : formatedplExpDate;
      }
        this.dashboardService.UpdateCompanyCOIChangeRequest(value).subscribe((data:any)=>{
          this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'Document Approved successfully' })
          this.getCompanyCOIChangeRequestDueList();
          this.getCompanyCOIChangeRequestArchiveList();
          if(data.statusId ==CompanyCOIChangeRequestStatus.Approved)
          {
            this.dashboardService.UpdateInvoiceStatus(data.companyId,Number(this.loggedInUserProfile.uid)).subscribe((data:any)=>{
    
           });
          }
    
        });
      }
    },
    reject:() =>{
    }});
  }

  reApproveCompanyDocumentDetails({ value }: { value: ICompanyCOIChangeRequestDetails })
  {
    this.confirmationService.confirm({
      key:'COIUpdateConfirm',
      message :'<center>Re-approving this document will replace the existing document in the vendor company profile. Please re-verify the existing document in the vendor company profile before re-approving it.</center><br/><center>Would you like to re-approve this document?</center>',
     //message: '<center>Please verify the email entered on the company profile is</center><center>'+' '+this.emailId.bold()+'.</center><center> You cannot change this email address after the save.</center><center>Select <strong>YES</strong> to continue or <strong>NO </strong>to go back and edit the email address',
     //message: '<center> Some insurance(s) are having an expired date. Would you like to approve the COI update request with expired dates? </center>',
     accept: () => {
      if(this.isApproveComments ==true){
        this.approveNotesDilaog=true;
        this.documnetReApproveDetailsDialog=false;
      }
      else{
      this.documnetReApproveDetailsDialog=false;
      value.documentId= this.requestId;
      value.documentFileName =  this.documentURL;
      value.documentTypeId=this.documentTypeId;
      value.modifiedBy = Number(this.loggedInUserProfile.uid);
      value.comments = null;
      this.dashboardService.UpdateCompanyCOIChangeRequest(value).subscribe((data:any)=>{
        this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'Document Approved successfully' })
        this.getCompanyCOIChangeRequestDueList();
        this.getCompanyCOIChangeRequestArchiveList();
        if(data.statusId ==CompanyCOIChangeRequestStatus.Approved)
        {
          //this.dashboardService.UpdateInvoiceStatus(data.companyId,Number(this.loggedInUserProfile.uid)).subscribe((data:any)=>{
  
         // });
        }
  
      });
    }
     },
     reject:() =>{
     }});
 
  }
  
}
